import React from "react";
import { Box } from "@chakra-ui/react";

const ImageBlockPreview = ({ block }) => {
    
    return (
        <Box
            style={{ marginTop: block.props.marginTop + "px", marginRight: block.props.marginRight + "px", marginBottom: block.props.marginBottom + "px", marginLeft: block.props.marginLeft + "px" }}
        >
       

            <img
                width="100%"
                height="200"
                src={`${block.props.imageUploadUrl}`}
                title="video preview"
                alt="video preview"
               
            />
        </Box>
    );
};

export default ImageBlockPreview;